// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Feature } from './feature';
import { ManufacturerFeatureKindMap } from './manufacturer-feature-kind-map';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class FeatureKind extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(50) */
  name!: string;
  /** Inv FK featureKindId */
  features!: Feature[];
  /** Inv FK featureKindId */
  manufacturerFeatureKindMaps!: ManufacturerFeatureKindMap[];
}

